import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import { useTranslatableField_text$key } from '__generated__/useTranslatableField_text.graphql';
import { useTranslatableField_data$key } from '__generated__/useTranslatableField_data.graphql';

export type TranslatableField = {
  [key: string]: string | null;
};

type Props = {
  text: useTranslatableField_text$key | null;
  data: useTranslatableField_data$key;
};

export function useTranslatableField(props: Props) {
  const field: TranslatableField = {};

  const text = useFragment(
    graphql`
      fragment useTranslatableField_text on Text {
        translations {
          edges {
            node {
              locale
              string
            }
          }
        }
      }
    `,
    props.text
  );

  const { languages } = useFragment(
    graphql`
      fragment useTranslatableField_data on Query {
        languages {
          locale
        }
      }
    `,
    props.data
  );

  languages.forEach(({ locale }) => {
    field[locale] =
      text?.translations?.edges.find(({ node }) => node.locale === locale)?.node
        .string ?? '';
  });

  return field;
}
